import React, { useState } from 'react';
import HookForm from '../../../../components/HookForm/HookForm';
import Datepicker from '../../../../components/Inputs/Datepicker/Datepicker';
import SelectClientIssuer from '../../../../components/Selects/SelectClientDocumentType';
import { MASK } from '../../../../constants/mask';

const CarSellerForm = ({ onSellerCreated, carData, currentData }) => {
  console.log(currentData)
  const [sellerForm, setSellerForm] = useState([
    {
      name: 'LastName',
      label: 'Фамилия',
      placeholder: '',
      rules: { required: true },
      value: currentData?.LastName,
      defaultValue: currentData?.LastName,
      capitalize: true,
    },
    {
      name: 'FirstName',
      label: 'Имя',
      placeholder: '',
      rules: { required: true },
      value: currentData?.FirstName,
      defaultValue: currentData?.FirstName,
      capitalize: true,
    },
    {
      name: 'MiddleName',
      label: 'Отчество',
      placeholder: '',
      value: currentData?.MiddleName,
      defaultValue: currentData?.MiddleName,
      capitalize: true,
    },
    {
      name: 'IIN',
      label: 'ИИН',
      placeholder: '900101300000',
      rules: {
        required: true,
        validate: (value) => {
          if (!value || value.length !== 12) {
            return 'ИИН должен содержать 12 цифр';
          }
          return true;
        }
      },
      mask: MASK.IIN,
      value: currentData?.IIN,
      defaultValue: currentData?.IIN,
    },
    {
      name: 'DOCUMENT_NUMBER',
      label: 'Номер удостоверения личности',
      placeholder: '123456789',
      rules: {
        required: true,
      },
      mask: MASK.DOCUMENT_NUMBER,
      value: currentData?.DOCUMENT_NUMBER,
      defaultValue: currentData?.DOCUMENT_NUMBER,
    },
    {
      name: 'DOCUMENT_GIVED_DATE',
      label: 'Дата выдачи документа',
      type: 'date',
      component: Datepicker,
      rules: { required: true },
      value: currentData?.DOCUMENT_GIVED_DATE,
      defaultValue: currentData?.DOCUMENT_GIVED_DATE,
    },
    {
      name: 'DOCUMENT_ISSUED_BY',
      component: SelectClientIssuer,
      label: 'Кем выдан',
      rules: { required: true },
      defaultValue: currentData?.DOCUMENT_ISSUED_BY,
    },
    {
      name: 'ADDRESS',
      label: 'Адрес',
      placeholder: 'г. Алматы, ул. Примерная, 2',
      rules: { required: true },
      value: currentData?.ADDRESS,
      defaultValue: currentData?.ADDRESS,
    },
    {
      name: 'CONTACT_PHONE',
      label: 'Номер телефона',
      placeholder: '77001234567',
      rules: { required: true },
      value: currentData?.CONTACT_PHONE,
      defaultValue: currentData?.CONTACT_PHONE,
      mask: MASK.PHONE,
    },
  ]);

  const handleSellerSubmit = (values) => {
    if (onSellerCreated) {
      onSellerCreated(values);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <HookForm
        inputs={sellerForm}
        title={'Данные продавца'}
        grid={{ display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr' }}
        handlerSetState={setSellerForm}
        onSubmit={handleSellerSubmit}
        action={'Далее'}
        border
      />
    </div>
  );
};

export default CarSellerForm; 